module.exports = __webpack_public_path__ + "img/trainingEquipmengtListNull.02c0ffc7.png";